import React, { useEffect } from 'react';
import moment from 'moment';
import GridTable from '@nadavshaar/react-grid-table';
import { gridTexts } from '../BarometroDetailsScreen';
import { TbPig } from 'react-icons/tb';
import { BiCheckCircle } from 'react-icons/bi';
import { FiAlertTriangle } from 'react-icons/fi';
import { AiFillCaretDown } from 'react-icons/ai';
import Pig from "../../assets/img/pig.png"
import './styles.scss';

const EmbrapaSuinosDetailsScreen = ({
  year,
  setYear,
  tab,
  setTab,
  selectedFarm,
  setSelectedFarm,
  allData,
  formattedData,
  totalAnnualVolume,
  nutrientOfferTable,
  netBenefit,
  volumeApplied,
  totalDemandVolume,
  haveExcessNutrients,
  waterMetric
}) => {

  useEffect(() => {
    console.log({selectedFarm, netBenefit, volumeApplied});
  } , [selectedFarm, volumeApplied, netBenefit])

  return <div className='suinos-details-screen'>
    <div className='card left'>
      <GridTable isPaginated={false} texts={gridTexts} columns={columns(setSelectedFarm)} rows={formattedData} />
    </div>
    <div className='card right'>
      {selectedFarm ? <>
        <YearSelection year={year} setYear={setYear} yearList={selectedFarm?.years ?? []}/>
        <div className='card-row'>
          <Aplication
            totalAnnualVolume={totalAnnualVolume}
            selectedFarm={selectedFarm}
            volumeApplied={volumeApplied}
            totalDemandVolume={totalDemandVolume}
          />
          <BeneficioLiqui value={netBenefit} />
        </div>
        <Tab
          waterMetric={waterMetric}
          tab={tab}
          setTab={setTab}
          selectedFarm={selectedFarm}
          allData={allData}
          nutrientOfferTable={nutrientOfferTable}
          haveExcessNutrients={haveExcessNutrients}
        />
      </> : <div>Selecione uma granja para continuar</div>}
    </div>
  </div>;
}

const columns = (setSelectedFarm) => [
  {
    id: 1,
    field: 'title',
    label: 'Nome',
    width: '400px',
    cellRenderer: ({ value, data }) => {
      return <div onClick={() => setSelectedFarm(data)} className='rgt-cell-inner rgt-text-truncate granja'>
        <TbPig />{value}
      </div>
    }
  }
];

export const YearSelection = ({ setYear, year: active, yearList = [] }) => {
  return <div className='year-selection-horizontal'>
    {yearList.map(year => <div  key={year} onClick={() => setYear(year)} className={`year ${year === active && 'active'}`}>{year}</div>)}
  </div>
}

export const Aplication = ({ selectedFarm, totalDemandVolume = 0, totalAnnualVolume = 0, volumeApplied = 0 }) => {
  const volumePercent = ((volumeApplied * 100) / totalAnnualVolume) || 0;
  const demandVolumePercent = ((totalDemandVolume * 100) / totalDemandVolume) || 0;
  
  return <div className='application'>
    <div>
      <img src={Pig} />
      <div>{`${selectedFarm?.accommodationCapacity ?? 0} Matrizes`}</div>
    </div>
    <div>
      <div className='text-title'>Aplicação de dejetos</div>
      <div className='text-title' style={{fontSize: '13px'}}>{volumeApplied} m³ Aplicado</div>
      <div className='bar'>
        <div className='second-bar' style={{ width: `${demandVolumePercent > 100 ? 100 : demandVolumePercent}%` }} />
        <div
          className='first-bar'
          style={{ width: `${volumePercent}%`, backgroundColor: `${volumeApplied > totalDemandVolume ? '#C22B00' : '#007937'}` }}
        />
      </div>
      <div className='text-subtitle'>{`${totalAnnualVolume} m³/ano`}</div>
    </div>
  </div>
}

export const BeneficioLiqui = ({ value }) => {
  return <div className='benefic'>
    <div className='text-title'>Benefício líquido com dejetos</div>
    <div className='text-value'>{`R$ ${value}`}</div>
  </div>
}

export const Tab = ({ tab, setTab, nutrientOfferTable, waterMetric, selectedFarm, allData, haveExcessNutrients }) => {

  const getNivel = () => {
    const value = selectedFarm?.waterConsumption || 'Baixo';

    if (value === 'Alto') {
      return 2
    } else if (value === 'Médio') {
      return 1
    } else if (value === 'Baixo') {
      return 0
    }
  }

  return <>
    <div className='tab-container'>
      <div className={`tab ${tab === 0 && 'active'}`} onClick={() => setTab(0)}>Qualidade do manejo</div>
      <div className={`tab ${tab === 1 && 'active'}`} onClick={() => setTab(1)}>Planejamento agrícola</div>
      <div className={`tab ${tab === 2 && 'active'}`} onClick={() => setTab(2)}>Todos os dados</div>
    </div>
    <div className='tab-panel'>
      {tab === 0 && <Qualidade value={getNivel()} haveExcessNutrients={haveExcessNutrients} waterMetric={waterMetric} />}
      {tab === 1 && <BalancoTable nutrientOfferTable={nutrientOfferTable}/>}
      {tab === 2 && <GridTable texts={gridTexts} columns={columnsAssistance} rows={allData || []} />}
    </div>
  </>
}

const QualityLabel = ({ haveExcessNutrients }) => {
  return haveExcessNutrients ? (
    <div className={`quality-label error`}>
      <FiAlertTriangle />
      <label>Excesso de nutrientes</label>
    </div>
  ) : (
    <div className={`quality-label success`}>
      <BiCheckCircle />
      <label>Equilibrado</label>
    </div>
  )
}

const priority = [
  { left: 16, label: 'Baixo' },
  { left: 50, label: 'Médio' },
  { left: 75, label: 'Alto' }
]

export const Qualidade = ({ value, haveExcessNutrients, waterMetric }) => {
  return <div className='qualidade'>
    <div className='balanco'>
      <div className='title'>Balanço de P2O5</div>
      <QualityLabel haveExcessNutrients={haveExcessNutrients}/>
    </div>
    <div className='consumo'>
      <div className='title'>Consumo de água</div>
      <div className='bar'>
        <div className='indicador-subtitle' style={{ left: `${priority[value].left - 4}%` }}>{priority[value].label}</div>
        <div className='indicador' style={{ left: `${priority[value].left}%` }}><AiFillCaretDown /></div>
        <div className='bar-1' />
        <div className='bar-2' />
        <div className='label-list'>
          {
            Array.isArray(waterMetric) && waterMetric.map(metric => (
              <span key={metric?.text}>{metric?.text}</span>   
            ))
          }
          {/* <span>8.3 L/cab./dia</span>
          <span>8.3 L/cab./dia</span>
          <span>8.3 L/cab./dia</span> */}
        </div>
      </div>
    </div>

  </div>
}

const BalancoTable = ({ nutrientOfferTable }) => {
  return <div className='balanco-table'>
    <label>Balanço de nutrientes</label>
    <div className='row'>
      {
        Array.isArray(nutrientOfferTable?.tableHead) && nutrientOfferTable.tableHead.map(head => (
          <div className='column'>{head}</div>
        ))
      }
    </div>
    {
      Array.isArray(nutrientOfferTable?.tableTitle) && nutrientOfferTable.tableTitle.map((title, idx) => (
       <div className='row'>
        <div className='column'>{title}</div>
        {
          Array.isArray(nutrientOfferTable?.tableData[idx]) && nutrientOfferTable.tableData[idx].map((value) => (
            <div className='column'>{value}</div>
          ))
        }
       </div>
      ))
    }
  </div>
}

const columnsAssistance = [
  {
    id: 1,
    field: 'Etapa',
    label: 'Etapa',
    cellRenderer: ({ value }) => <div className='rgt-cell-inner rgt-text-truncate granja'>
      {value === 'Cadastro' ? 'Granja' : value}
    </div>
  },
  {
    id: 2,
    field: 'Pergunta',
    label: 'Pergunta',
    width: 'calc(100% - 400px)'
  },
  {
    id: 3,
    field: 'Resposta',
    label: 'Resposta'
  }
]

export default EmbrapaSuinosDetailsScreen;